/**
 * Labstep
 */

export enum NodeKeys {
  protocol_step = 'protocol_step',
  experiment_step = 'experiment_step',
}
